export enum ThemeType {
    SAMPLE1 = "sample5",
    SAMPLE2 = "sample5",
    SAMPLE3 = "sample5",
    SAMPLE4 = "sample5",
    SAMPLE5 = "sample5",
    // SAMPLE52 = 'sample52',
}

export enum SiteCode {
    Arte = "arte",
    Armour = "armour",
    BlueDragon = "bluedragon",
    Nothing = "nothing",
    ChonWon = "chonwon",
}

export enum SportsType {
    PREMATCH = "prematch",
    INPLAY = "inplay",
    CROSS = "cross",
    SPECIAL = "special",
}

export enum BetStatus {
    Open = 1,
    Suspended = 2,
    Settled = 3,
}

export enum BetSettlement {
    Canceled = -1,
    Loser = 1,
    Winner = 2,
    Refund = 3,
    HalfLost = 4,
    HalfWon = 5,
}

export enum MarketViewMode {
    MORDEN,
    ASIAN,
    SUB,
    CROSS,
    SPECIAL,
    INPLAY,
}

export enum MarketViewType {
    WINNER,
    UNDEROVER,
    HANDICAP,
}

export enum SportId {
    FOOT_BALL = 6046,
    ICE_HOKEY = 35232,
    HAND_BALL = 35709,
    BASKET_BALL = 48242,
    BASE_BALL = 154914,
    RUGBY_UNION = 274791,
    TENIS = 54094,
    TABLE_TENIS = 265917,
    CRICKET = 452674,
    BOXING = 154919,
    AMERICAN_FOOTBALL = 131506,
    VOLLEY_BALL = 154830,
    FLOOR_BALL = 35706,
    EGAMES = 687890,
    SNOOKER = 262622,
    BADMINTON = 1149093,
    DARTS = 154923,
    KABADDI = 1149123,
    HOCKEY = 530129,
    RUGBY_LEAGUE = 274792,
    AUSTRALIAN_RULES = 389537,
}

// E-스포츠 ID 상수
export const ESportsId = 687890;

export enum LSportsFixtureStatus {
    NOTSTARTEDYET = 1,
    PROGRESS = 2,
    FINISHED = 3,
    CANCELED = 4,
    POSTPONED = 5,
    INTERRUPTED = 6,
    ABANDONED = 7,
    COVERAGELOST = 8, // The coverage for this event has been lost
    ABOUTTOSTART = 9, // The event has not started but is about to. NOTE= This status will be shown up to 30 minutes before the event has started
}

export enum SocketMessageCode {
    HeartBeat = 0,
    Prematch_Category = 10,
    EPrematch_Category = 11,
    Prematch_Fixture = 101,
    // Prematch_LiveScore      = 102,
    Prematch_Market = 103,
    // Prematch_Settlement     = 135,
    Inplay_Category = 20,
    EInplay_Category = 21,
    Inplay_Fixture = 201,
    Inplay_LiveScore = 202,
    Inplay_Market = 203,
    // Inplay_Settlement       = 235,
    UserBalance = 300,
    Inquiry = 400,
    Notice = 450,
    Message = 451,
    Deposit = 500,
    Withdraw = 510,
    MiniGame = 600,
    ReloadMiniGameBetLog = 601,
    ReloadVSportsBetLog = 602,

    // 쿠폰 관련 메시지 코드
    CouponUsage = 700, // 쿠폰 사용 알림
    CouponExpiration = 701, // 쿠폰 만료 예정 알림
    CouponCycleUpdate = 702, // 쿠폰 회차 정보 업데이트
    CouponIssued = 703, // 쿠폰 발급 알림

    Logout = 999,
}

export enum MiniGameBetStatus {
    Pending = 0,
    Win = 1,
    Lost = 2,
    Refund = 3,
}

export enum UserDepositBonusType {
    None = "none",
    First = "first",
    DailyFirst = "daily_first",
    ReCharge = "recharge",
    CasinoBonus = "casino",
    SlotBonus = "slot",
    Surprise = "surprise",
    Surprise2 = "surprise2",
}

export enum VSportsBetStatus {
    Pending = 0,
    Win = 1,
    Lost = 2,
    Refund = 3,
}

export enum CouponStatus {
    UNUSED = "unused",
    USED = "used",
    CANCELED = "canceled",
    EXPIRED = "expired",
}
